import { useEffect, useReducer, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { store } from 'Store';
import { Row, Col, Card, Badge, Form, Stack } from "react-bootstrap";
import { getUserProfileInfo, submitEditUserProfileData } from "./EditUserProfileAxiosFuncs";
import { ACTIONS, formInfoReducer } from "./EditUserProfileFormDataReducer";
import { FormTextInput } from "Components/Forms/FormInput";
import PasswordInput from "../Component/PasswordInput";
import { STATUSES, ERROR_MESSAGES } from "Utils/constants";
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import { TextButton } from 'Components/Button';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { useNavigate } from "react-router-dom";
import { setFirstName, setLastName } from "Store/LoginInfoSlice";

const nameConverter = {
  "firstname": "firstname",
  "middlename": "middlename",
  "lastname": "lastname",
  "prefix": "prefix",
  "suffix": "suffix",
  "credentials": "credentials",
  "jobTitle": "jobTitle",
  "address1": "address1",
  "address2": "address2",
  "city": "city",
  "state": "state",
  "zip": "zip",
  "zipext": "zipext",
  "phoneForDisplay": "phone",
  "phonextn": "phonextn",
  "faxForDisplay": "fax",
  "emailaddress": "emailaddress",
  "editUserPassword": "editUserPassword"
}

const EditUserProfile = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginState = store.getState().loginInfo;
  const token = "Bearer " + loginState.token;

  const initialState = {
    data: '',
    loading: true,
    error: null,
  };

  const [formInfo, formInfoDispatch] = useReducer(formInfoReducer, initialState);
  const [userInfo, setUserInfo] = useState(null);

  const formFieldDisplay = {
    firstname: {
      type: 'text',
      id: 'firstname',
      name: 'firstname',
      display: {
        label: 'First Name',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    middlename: {
      type: 'text',
      id: 'middlename',
      name: 'middlename',
      display: {
        label: 'MI',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    lastname: {
      type: 'text',
      id: 'lastname',
      name: 'lastname',
      display: {
        label: 'Last Name',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    prefix: {
      type: 'select',
      id: 'prefix',
      name: 'prefix',
      display: {
        label: 'Prefix',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    suffix: {
      type: 'select',
      id: 'suffix',
      name: 'suffix',
      display: {
        label: 'Suffix',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    credentials: {
      type: 'text',
      id: 'credentials',
      name: 'credentials',
      display: {
        label: 'Credentials',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    jobTitle: {
      type: 'text',
      id: 'jobTitle',
      name: 'jobTitle',
      display: {
        label: 'Job Title',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    address1: {
      type: 'text',
      id: 'address1',
      name: 'address1',
      display: {
        label: 'Business Address Line 1',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    address2: {
      type: 'text',
      id: 'address2',
      name: 'address2',
      display: {
        label: 'Business Address Line 2',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    city: {
      type: 'text',
      id: 'city',
      name: 'city',
      display: {
        label: 'City',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    state: {
      type: 'select',
      id: 'state',
      name: 'state',
      display: {
        label: 'State',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    zip: {
      type: 'text',
      id: 'zip',
      name: 'zip',
      display: {
        label: 'Zip Code',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    zipext: {
      type: 'text',
      id: 'zipext',
      name: 'zipext',
      display: {
        label: 'Zip Extension',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    phone: {
      type: 'tel',
      id: 'phone',
      name: 'phone',
      display: {
        label: 'Phone Number',
        description: "(###) ###-####",
        title: "",
        placeholder: null,
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    phonextn: {
      type: 'text',
      id: 'phonextn',
      name: 'phonextn',
      display: {
        label: 'Phone Extension',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    fax: {
      type: 'tel',
      id: 'fax',
      name: 'fax',
      display: {
        label: 'Fax Number',
        description: "(###) ###-####",
        title: "",
        placeholder: null,

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    emailaddress: {
      type: 'text',
      id: 'emailaddress',
      name: 'emailaddress',
      display: {
        label: 'Email Address',
        description: "",
        title: "",

      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    },
    editUserPassword: {
      type: 'text',
      id: 'editUserPassword',
      name: 'editUserPassword',
      display: {
        label: "",
        description: "",
        title: "",
      },
      hideFieldOrgTypes: [],
      InputRef: useRef(null)
    }
  }

  const prefixListValues = (prefixList, selectedValue) => {
    //console.log("prefixListValues", prefixList, selectedValue);

    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Select Prefix",
      isSelected: selectedValue == null ? true : false
    });

    for (var i = 0; i < prefixList.length; i++) {
      var x = prefixList[i];
      objArr.push({
        index: x.prefix,
        value: x.prefix,
        title: "Select prefix " + x.prefix,
        displayValue: x.prefix,
        isSelected: selectedValue == x.prefix ? true : false
      });
    }

    return objArr;
  };

  const suffixfixListValues = (suffixList, selectedValue) => {
    //console.log("suffixfixListValues", suffixList, selectedValue);

    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Select Suffix",
      isSelected: selectedValue == null ? true : false
    });

    for (var i = 0; i < suffixList.length; i++) {
      var x = suffixList[i];
      objArr.push({
        index: x.suffix,
        value: x.suffix,
        title: "Select suffix " + x.suffix,
        displayValue: x.suffix,
        isSelected: selectedValue == x.suffix ? true : false
      });
    }

    return objArr;
  };

  const stateListValues = (stateList, selectedValue) => {
    //console.log("stateListValues", stateList, selectedValue);
    var objArr = [];
    objArr.push({
      index: 0,
      value: null,
      title: null,
      displayValue: "Select State",
      isSelected: selectedValue == null ? true : false
    });

    for (var i = 0; i < stateList.length; i++) {
      var x = stateList[i];
      objArr.push({
        index: x.regionId,
        value: x.regionId,
        title: "Select state " + x.name,
        displayValue: x.name,
        isSelected: selectedValue == x.regionId ? true : false
      });
    }

    return objArr;
  };


  const handleInputTextChange = (e) => {
    //console.log("print out the text input change", e, e.target.value);
    const val = e.target.value;

    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: val,
      name: e.target.name
    });
  }

  const handleSelectChange = (e) => {
    //console.log("print out vendor select change", e);
    formInfoDispatch({
      type: ACTIONS.SELECT_CHANGE,
      value: e.target.value,
      name: e.target.name
    })
  }

  const handleInputTelChange = (value, data, event, formattedValue) => {

    //console.log("print out the tel input change", value);

    formInfoDispatch({
      type: ACTIONS.TEXT_CHANGE,
      value: formattedValue,
      name: event.target.id
    });
  }

  var dispLabel = (fieldName, isHidden, getColLabelSizes, alignment, multi) => {

    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];

    //console.log("print out data, dispData, fieldName", data, dispData.display.label, fieldName, formInfo);

    if (alignment == Row) {
      if (multi == true) {
        return (
          <Col hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {<span className="me-2">{dispData.display.label}</span>}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Col>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden} column
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {<span className="me-2">{dispData.display.label}</span>}
            {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
    else {
      if (multi == true) {
        return (
          <Row hidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            <legend>
              {dispData.display.label}
              {data.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
            </legend>
          </Row>
        );
      }
      else {
        return (
          <Form.Label visuallyHidden={isHidden}
            xs={getColLabelSizes('xs')}
            sm={getColLabelSizes('sm')}
            md={getColLabelSizes('md')}
            lg={getColLabelSizes('lg')}
            xl={getColLabelSizes('xl')}
            xxl={getColLabelSizes('xxl')}
          >
            {dispData.display.label}
            {data.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
          </Form.Label>
        );
      }
    }
  };

  var dispErrors = (fieldName) => {
    var data = formInfo.data[fieldName];
    var dispData = formFieldDisplay[fieldName];
    return (
      <div>
        {data.validation.errors.length > 0 ? data.validation.errors.map((errorText, index) =>
          <Stack key={dispData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
            <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
            <div>{errorText}</div>
          </Stack>

        ) : null}
      </div>
    );
  }

  const addErrorMessages = (fieldName, errorFieldName, data, isFirst) => {
    var d = data.fieldErrors;
    var values = d[errorFieldName];
    //console.log("addErrorMessages", values);

    if (values != null) {
      var field = formFieldDisplay[fieldName];
      var type = field.type;
      var err = values.errorMessages;

      //console.log(err);

      if (isFirst == true) {
        (field.InputRef).current.focus();
        //console.log("ISFIRST");
      }

      switch (type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "password":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;

        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
        case "tel":
          formInfoDispatch({
            type: ACTIONS.TEXT_SET_ERRORS,
            name: fieldName,
            errors: err
          })
          break;
      }

    }
  }

  function clearErrorMessages (data) {
    for (const [key, value] of Object.entries(data)) {
      var t = formFieldDisplay[key];
      var fieldName = key;
      switch (t.type) {
        case "text":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "password":
          formInfoDispatch({
            type: ACTIONS.TEXT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
        case "select":
          formInfoDispatch({
            type: ACTIONS.SELECT_REMOVE_ERRORS,
            name: fieldName
          })
          break;
      }

    }
  }

  function getFieldValue (fieldName, data) {
    var values = data[fieldName];
    var dispValues = formFieldDisplay[fieldName];

    //console.log(values);
    if (formInfo.loading) {
      return '';
    }
    else {
      var type = dispValues.type;
      switch (type) {
        case "text":
          if (values.value != null) {
            return values.value;
          }
          return "";
        case "password":
          if (values.value != null) {
            return values.value;
          }
          return "";
        case "select":
          if (values != null) {
            var arr = values.options;
            //console.log("ARR");
            //console.log(arr);
            for (var x = 0; x < arr.length; x++) {
              var val = arr[x];
              if (val.isSelected) {
                return val.value;
              }
            }
          }
          return null;
        case "tel":
          if (values.value != null) {
            return values.value;
          }
          return "";

        default:
          return "";
      }
    }

  }

  // initial load
  useEffect(() => {
    getUserProfileInfo(ACTIONS, formInfoDispatch, handleInputTextChange, handleSelectChange, handleInputTelChange, { prefixListValues, suffixfixListValues, stateListValues }, token)
      .then((res) => {
        //console.log("getUserProfileInfo use effect res", res);
        if (res !== null && res !== undefined) {
          var statusCode = res.data.status;
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: true
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
          }
          setUserInfo(res.data.data?.userInfo);
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
  }, []);

  // submit data
  const handleSubmit = () => {
    submitEditUserProfileData(userInfo, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue, token)
      .then((res) => {
        //console.log("handleSubmit submitEditUserProfileData", res);
        if (res !== null && res !== undefined) {
          var statusCode = res.data.status;
          switch (statusCode) {
            case STATUSES.ERROR.code:
              if (res.data.globalErrorMessageList && res.data.globalErrorMessageList.length != 0) {
                setGlobalErrorStatus({
                  dispatch: dispatch,
                  popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: res.data.globalErrorMessageList,
                    showContactHelp: true
                  },
                  redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                  }
                })
              };
              break;
            case STATUSES.SUCCESS.code:
              setGlobalSuccessStatus({
                dispatch: dispatch,
                popupData: {
                  visible: true,
                  title: "Success!",
                  msg: res.data.message,
                  showContactHelp: false
                },
                redirect: {
                  redirect: true,
                  redirectFirst: true,
                  // default path is ""
                  path: "/dashboard",
                  data: {}
                }
              });
              // clear password input field
              formInfoDispatch({
                type: ACTIONS.TEXT_CHANGE,
                value: "",
                name: "editUserPassword"
              });
              // scroll to top
              window.scrollTo(0, 0);
              // reflect top right corner login user name immediately
              dispatch(setFirstName(getFieldValue("firstname", formInfo.data)));
              dispatch(setLastName(getFieldValue("lastname", formInfo.data)));
              break;

          }
        }
      }).catch((error) => {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: ERROR_MESSAGES.DATA_ERROR.message,
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          },
          error: error
        });
      });
  }

  const handleCancel = () => {

    navigate("/dashboard");
  }

  return (
    <>
      <Row>
        {formInfo.loading ? null :
          <Col xl={11} lg={11} md={11} sm={12}>
            <Card className="p-4">
              <Card.Body className="text-start">
                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
                  My Profile
                </h1>
                <p>Update your user information below. To save your changes, enter your password at the bottom of the page. To update your email and address information please contact the PSOPPC at <a className={"supportEmail"} href="mailto:support@psoppc.org">support@psoppc.org</a>.</p>
                <p>The information on this page is user specific and is not the official organization contact information.</p>
                <p>To update the PSO contact information please contact AHRQ at <a className={"supportEmail"} href="mailto:PSO@ahrq.hhs.gov">PSO@ahrq.hhs.gov</a>.</p>
                <p className="form-title"></p>
                <Form>
                  <FormTextInput fieldName="firstname" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="middlename" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="lastname" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="prefix" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                  <FormTextInput fieldName="suffix" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                  <FormTextInput fieldName="credentials" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={4000}></FormTextInput>
                  <FormTextInput fieldName="jobTitle" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={100}></FormTextInput>
                  <FormTextInput fieldName="address1" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="address2" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="city" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={75}></FormTextInput>
                  <FormTextInput fieldName="state" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                  <FormTextInput fieldName="zip" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={6}></FormTextInput>
                  <FormTextInput fieldName="zipext" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={4}></FormTextInput>
                  <FormTextInput fieldName="phone" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={14}></FormTextInput>
                  <FormTextInput fieldName="phonextn" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={6}></FormTextInput>
                  <FormTextInput fieldName="fax" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors} maxLength={14}></FormTextInput>
                  <FormTextInput fieldName="emailaddress" hideLabel={false} horizontalForm={{ is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } }} displayLabelFunc={dispLabel} data={formInfo.data} fieldData={formFieldDisplay} displayErrorsFunc={dispErrors}></FormTextInput>
                  <h2>Authorize and Update Changes</h2>
                  <div>Enter your password and submit to update account information.</div>
                  <PasswordInput fieldName={"editUserPassword"} formInfo={formInfo} formFieldDisplay={formFieldDisplay} col={5}></PasswordInput>
                  <br />
                  <TextButton
                    variant="normal"
                    onClick={handleSubmit}
                    content={"Submit"}
                  >
                  </TextButton>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <TextButton
                    variant="outline"
                    onClick={handleCancel}
                    content={"Cancel"}
                  >
                  </TextButton>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        }
      </Row>
    </>
  )
}

export default EditUserProfile;